export const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

// Fecha o modal apenas quando o clique INICIA e TERMINA no overlay.
// Evita fechar quando o usuário arrasta uma seleção de texto e solta fora do modal.
// Uso: <div {...overlayCloseProps(onClose)}>...</div>
// Estado é guardado no dataset do próprio elemento (não usa hooks → seguro em modais condicionais).
export function overlayCloseProps(onClose) {
  return {
    onMouseDown: (e) => {
      e.currentTarget.dataset.downOnOverlay = e.target === e.currentTarget ? '1' : '0';
    },
    onClick: (e) => {
      const wasDownOnOverlay = e.currentTarget.dataset.downOnOverlay === '1';
      delete e.currentTarget.dataset.downOnOverlay;
      if (wasDownOnOverlay && e.target === e.currentTarget) onClose();
    },
  };
}

// Formata telefone BR como "(XX) XXXXX-XXXX"
export function formatarTelefone(tel) {
  if (!tel) return '';
  const d = String(tel).replace(/\D/g, '');
  const num = (d.length === 12 || d.length === 13) && d.startsWith('55') ? d.slice(2) : d;
  if (num.length === 11) return `(${num.slice(0, 2)}) ${num.slice(2, 7)}-${num.slice(7)}`;
  if (num.length === 10) return `(${num.slice(0, 2)}) ${num.slice(2, 6)}-${num.slice(6)}`;
  if (num.length === 9) return `${num.slice(0, 5)}-${num.slice(5)}`;
  if (num.length === 8) return `${num.slice(0, 4)}-${num.slice(4)}`;
  return tel;
}

// Formata "fatias" do tamanho de bolo conforme o tipo de medida.
// 'kg'  → "1,5 kg" (uma casa decimal, vírgula)
// outro → "18 fatias" (inteiro, plural)
export function formatFatiasKg(fatias, tipoMedida) {
  const n = Number(fatias) || 0;
  if (tipoMedida === 'kg') {
    return `${n.toFixed(1).replace('.', ',')} kg`;
  }
  const inteiro = Math.round(n);
  return `${inteiro} fatia${inteiro === 1 ? '' : 's'}`;
}
